import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'material-ui';
import themeStyles from '../../../materialUiTheme';

import noop from '../../../core/modules/common/tools/noop';

const OnlySelectedFilterCheckbox = (props) => {
  const {
    isDisabled = false,
    isShowOnlySelected = false,
    onShowOnlySelected = noop,
  } = props;

  return (
    <Checkbox
      {...themeStyles.showOnlySelected}
      checked={isShowOnlySelected}
      onCheck={onShowOnlySelected}
      disabled={isDisabled}
      label="Show only selected"
    />
  );
};
export default OnlySelectedFilterCheckbox;

OnlySelectedFilterCheckbox.propTypes = {
  isDisabled: PropTypes.bool,
  isShowOnlySelected: PropTypes.bool,
  onShowOnlySelected: PropTypes.func,
};
